module.exports = __webpack_public_path__ + "img/lsfb.d4b3991b.svg";